import type { ShipmentModifiedByDetailsResponse } from './api';

export const normalizeShipmentModifiedByDetails = (
  list: ShipmentModifiedByDetailsResponse,
): { label: string; value: number }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.modifiedByFullDesc,
    value: row.modifiedBy,
  }));
};
